import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ICampaign } from '@user/store/campaigns'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '../../../typings'

type Props = {
  leadSourceRequired: boolean
  required: boolean
  show: boolean
  name: string
  density: DensityType
}

export default function CampaignSelect(props: Props) {
  const { required, show, name, leadSourceRequired, density } = props
  const {
    getOptionLabel,
    options,
    initialOption,
    getId,
    isSubmitting,
    showError,
    helperText,
  } = useData({ required, name })
  const { handelChange } = useHandlers({ name, required, leadSourceRequired })

  return show ? (
    <Box>
      <Select<ICampaign>
        density={density}
        disabled={isSubmitting}
        required={required}
        error={showError}
        disableClearOnBlur
        getLabel={getOptionLabel}
        getId={getId}
        items={options}
        onChange={handelChange}
        value={initialOption}
        label={'Campaign'}
        optionMode={'normal'}
        testId="campaign-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
